import { PropertyFormValues } from '@app/sign-up/forms/property.form';
import { ErrorModel } from '@shared-lib/models/error.model';

export interface SignUpPropertyState {
  entity: PropertyFormValues | null;
  loading: boolean;
  errors: ErrorModel | null;
}

export const signUpPropertySelectorName = 'signUpProperty';
